(ns ui.components.radix-ui.index
  (:require
   [reagent.core :as r]
   ["@radix-ui/react-portal" :as Portal]))

; Boilerplate for adapt function
(defn adapt
  [cls-name]
  (r/adapt-react-class (aget "<component>" cls-name)))

(defn adapt-portal
  [cls-name]
  (r/adapt-react-class (aget Portal cls-name)))


(defn portal
  ([body]
   [portal {} body])
  ([props body]
   (let [portal-component (adapt-portal "Root")]
     [portal-component
      body])))
